export default __webpack_public_path__ + "static/media/rs-arte-15.54c3c9ec.webp";